// Angularバージョン(1桁目: メジャーバージョンアップ, 2桁目: マイナーバージョンアップ, 3桁目: バグ修正更新)
export const VERSION = 'ver.2.41.181';
// Smile9APIバージョン(=API Gatewayのステージ変数"alias"の値。本番環境のみ参照。)
export const SMILE9_API_ALIAS_VERSION = 'alias-11';
// SKS-Master-APIバージョン(=API Gatewayのステージ変数"alias"の値。本番環境のみ参照。)
export const SKS_MASTER_API_ALIAS_VERSION = 'v1-14-15';
// RsvCalendarAPIバージョン(=API Gatewayのステージ変数"alias"の値。本番環境のみ参照。)
export const RSV_CALENDAR_API_ALIAS_VERSION = 'v1-0-0';
// DlDLAPIバージョン(=API Gatewayのステージ変数"alias"の値。本番環境のみ参照。)
export const DLDATA_API_ALIAS_VERSION = 'alias-2';
